import { GlobalErrorHandling } from 'components/GlobalErrorHandling';
import { User } from 'components/Header/User';
import { MainMenu } from 'components/Header/User/MainMenu';
import { Notifications } from 'components/Notifications';
import { HeaderModule, Text, Theme, presetGpnDefault, HeaderLogo, Header } from 'uikit';

import type { ReactNode } from 'react';

export const HEADER_HEIGHT = 60;

export const MasterLayout = ({ children = null }: { children: ReactNode }): JSX.Element => (
    <Theme preset={presetGpnDefault} style={{ height: '100%' }}>
        <Header
            leftSide={
                <>
                    <HeaderModule>
                        <HeaderLogo>
                            <Text as="p" size="l" weight="bold">
                                РиМ
                            </Text>
                        </HeaderLogo>
                    </HeaderModule>
                    <HeaderModule indent="l">
                        <MainMenu />
                    </HeaderModule>
                    <Notifications />
                    <GlobalErrorHandling />
                </>
            }
            rightSide={<User />}
            style={{ height: HEADER_HEIGHT }}
        />
        {children}
    </Theme>
);

MasterLayout.displayName = 'MasterLayout';
